/*

Set year mixin sets a variable to the current year, to lessen hard coded dates in our code

Usage:
  import set-Year mixin with path '@/mixins/setYear'

*/

export default {
  methods: {
    setYear: function () {
      const today = new Date()
      const year = today.getFullYear()

      this.currentYear = year
    }
  },
  data: function () {
    return {
      currentYear: 0
    }
  },
  mounted: function () {
    this.setYear()
  }
}
